import React from 'react';
import { Col } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ControlWrapper = ({ col = {}, field = {}, onClick = () => {}, highlight = false, children }) => {
  // const [isHovering, setIsHovering] = useState(false);

  const xxlValue = (col && (col.xxl || col.xl || col.lg || col.md)) || 12;
  const controlId = field.name === 'itemid' ? 'itemid' : field.identifier;
  const style = field.style || 'default';
  const isAutoCalculated = field.calculated === true;

  const className = classNames('control-wrapper', {
    'item-id-wrapper': field.name === 'itemid',
    'is-enabled': !field.readOnly && !field.disabled && !field.hidden && !isAutoCalculated,
    'is-entered': !isAutoCalculated,
    'is-calculated': isAutoCalculated,
    'is-readonly': (field.readOnly || field.disabled) && field.control !== 'Paragraph',
    'is-hidden': field.hidden,
    'c-2-e': field.clickToEdit,
    highlight,
    [style]: true,
    // 'is-hovering': isHovering,
  });

  // const handleMouseOver = () => {
  //   setIsHovering(true);
  // };

  // const handleMouseOut = () => {
  //   setIsHovering(false);
  // };

  return (
    <Col
      className={classNames(className, `col-xxl-${xxlValue}`)}
      id={`${controlId}-wrapper`}
      // xxl={{ span: (col && (col.xxl || col.xl || col.lg || col.md)) || 12, offset: col && col.xxlOffset }}
      xl={{ span: (col && (col.xl || col.lg || col.md)) || 12, offset: col && col.xlOffset }}
      lg={{ span: (col && (col.lg || col.md)) || 12, offset: col && col.lgOffset }}
      md={{ span: (col && (col.md || col.sm)) || 12, offset: col && col.mdOffset }}
      sm={{ span: (col && col.sm) || 12, offset: col && col.smOffset }}
      xs={{ span: (col && col.xs) || 12, offset: col && col.xsOffset }}
      onClick={() => {
        onClick(field.name);
      }}
      // onMouseOver={handleMouseOver}
      // onMouseOut={handleMouseOut}
    >
      {children}
    </Col>
  );
};

ControlWrapper.propTypes = {
  col: PropTypes.object,
  field: PropTypes.object,
  highlight: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

export default ControlWrapper;
